__webpack_require__.p = "/jewelry/";